import React, { Component } from 'react';




import { apiPut, apiPost, apiDelete } from '../../Api';
import EnemyList from './Admin_Enemy_List';
import EnemyDetail from './Admin_Enemy_Detail';
import AdminAPI from './AdminAPI';
import ItemsModal from './ItemsModal';



export default class Admin_Enemy extends Component {


  constructor(props) {
    super(props);
    this.state = {
      enemies: [], // Load this from your backend
      regions: [], // Load this from your backend
      enemyTypes: [],
      baseTiles: [],
      detailTiles: [],

      creatingNewEnemy: false,
      selectedEnemyId: "",
      selectedItem: null,
      showItemPopup: false,//modal
    }
  }





  componentDidMount = async () => {
    const [regions, enemies, enemyTypes, baseTiles, detailTiles] =
      await Promise.all([
        AdminAPI.getRegions(),
        AdminAPI.getEnemies(),
        AdminAPI.getEnemyTypes(),
        AdminAPI.getTileTypes({ type: 'baseTile' }),
        AdminAPI.getTileTypes({ type: 'detail' }),
      ]);
    this.setState({ regions, enemies, enemyTypes, baseTiles, detailTiles });

  }

  handleSelectEnemy = (region) => {

    this.setState({
      selectedEnemy: region,
      creatingNewEnemy: false,
      selectedEnemyId: region.id,
      selectedHuntingGroundId: ""
    });

  };

  handleNewEnemy = () => {
    this.setState({
      creatingNewEnemy: true,
      selectedEnemy: {},
      selectedEnemyId: ""
    });
  };


  handleCancelCreate = () => {
    this.setState({
      selectedEnemy: null,
      creatingNewEnemy: false,
    });
  };

  handleUpdate = async (enemies) => {
    const response = await apiPut("/enemy", JSON.stringify(enemies));
    if (response.ok) {
      this.setState({ enemies: await AdminAPI.getEnemies() });
      this.setState({ selectedEnemyId: null });
    }
  };

  handleDelete = async (enemies) => {
    // Send delete request to your backend
    const response = await apiDelete("/enemy/" + enemies.id);
    if (response.ok) {
      this.setState({ enemies: await AdminAPI.getEnemies() });
      this.setState({ selectedEnemyId: null });
    }
  };

  handleCreate = async (enemies) => {
    // Send delete request to your backend
    const response = await apiPost("/enemy", JSON.stringify(enemies));

    if (response.ok) {
      this.setState({ enemies: await AdminAPI.getEnemies() });
      this.setState({ selectedEnemyId: null });
    }
    else {
      window.alert(response.text());
    }
  };
  handleSearch = (searchQuery) => {
    // Filter the enemies based on search query
  };



  handleSelectItemPopup = (item) => {//Modal
    this.setState({
      selectedItem: item,
      showItemPopup: false
    });
  }

  showItemPopup = () => {
    this.setState({ showItemPopup: true })
  }





  render() {
    const { enemies, creatingNewEnemy } = this.state;
    const { showItemPopup } = this.state;
    return (
      <div className="admin-settingspage">
        <EnemyList
          enemies={enemies}
          filter={this.props.filter}
          regions={this.state.regions}
          onSelectEnemy={this.handleSelectEnemy}

          onNewEnemy={this.handleNewEnemy}
        />



        <EnemyDetail
          regions={this.state.regions}
          enemyTypes={this.state.enemyTypes}
          baseTiles={this.state.baseTiles}
          detailTiles={this.state.detailTiles}
          showItemPopup={this.showItemPopup}
          creatingNewEnemy={creatingNewEnemy}
          enemyId={this.state.selectedEnemyId}
          onUpdate={this.handleUpdate}
          onDelete={this.handleDelete}
          onCreate={this.handleCreate}
          onCancelCreate={this.handleCancelCreate}
          selectedItem={this.state.selectedItem}
        />

        {showItemPopup && <ItemsModal onSelect={this.handleSelectItemPopup} onClose={() => this.setState({ showItemPopup: false })} />}
      </div>
    );
  }
}
